module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Rectangle_808@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FRectangle_808%402x.png
// module id = 4vRg
// module chunks = 93